import React, { useEffect, useState } from 'react';
import { Table, Spin, Button, TableColumnsType, InputRef, Input, Space } from 'antd';
import { formatNumberWithCommas, formatToTwoDecimalPlaces, rejectedApiMessage } from '../../utilities/CommonHelper';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOBOReport_AllChildOpps } from '../../store/reducers/oboDashboardSlice';
import { ColumnType, FilterConfirmProps, TablePaginationConfig } from 'antd/es/table/interface';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

interface OboChildOppDetailsTableContainerProps {
  parentOpp: any; // Parent opportunity data passed as props
  openSOWFromChild: (data: any, level: any) => void;
  refreshchildData: (data: any) => void;
  ischildDataRefresh: boolean;
}

interface DataType  {
    key :React.Key;
    client: string
    opportunityID: string;
    opportunityName: string;
    sumOfTCV: string;
    revenue: string;
    obo: string;
    countOfSow: any;
    countOfChildOpp: any;
    
  }
  type DataIndex = keyof DataType;

const OboChildOppDetailsTableContainer: React.FC<OboChildOppDetailsTableContainerProps> = ({ parentOpp, openSOWFromChild, refreshchildData,ischildDataRefresh }) => {
    const dispatch = useDispatch();
    const filterData = useSelector((state: any) => state.oboReports.filterData);
    const [childOppData, setChildOppData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [dataCalled, setDataCalled] = useState<boolean>(false);

    const [searchText, setSearchText] = React.useState('');
	  const [searchedColumn, setSearchedColumn] = React.useState('');
    const searchInput = React.useRef<InputRef>(null);

    const [pageNo, setPageNo] = React.useState<number>(0);
    const [pageSize, setPageSize] = React.useState<number>(10);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [filters, setFilters] = React.useState<any>([]);
    
    
    const handleTableChange = (pagination: TablePaginationConfig,filters:any) => {
          const { current, pageSize } = pagination;
          const _current = current ? current - 1 : 0;
          setPageNo(_current);
          setPageSize(pageSize || 10);
          const _filters:any[] =[];
           Object.keys(filters).map((key) => {
            debugger;
            if(filters[key] && filters[key]!==undefined ){
      
            if(key==="opportunityID"){
              _filters.push({field:key,value:filters[key][0],operator:'EQUALS'});
            }
            else{
              _filters.push({field:key,value:filters[key][0],operator:'LIKE'});
            }
            
            }
          })
          setFilters(_filters);
          dispatch(fetchOBOReport_AllChildOpps({
                'payload':{'parentOppID': parentOpp.opportunityID ,'startDate':filterData.startDate,'endDate':filterData.endDate, 
                  'clientName':filterData.clientName,
                  'buName':getSelectedBu(filterData.buName),
                  'page':0,
                  'size':10,
                  'filters':_filters
                }
                })).then((res:any) => {
                if(res.type!=="oboReports/fetchOBOReport_AllChildOpps/fulfilled"){
                    rejectedApiMessage(res.payload);
                    setLoading(false);
                    
                }
                else{
                        // setOBOReportData(res.payload.data);
                        let _temp = addkeytoData(res.payload.content);
                        setChildOppData(_temp);
                        setLoading(false);
                        setTotalCount(res.payload?.totalElements);
           		          setPageNo(_current);

                }
                
            }
        );
      };


	const handleSearch = (
		selectedKeys: string[],
		confirm: (param?: FilterConfirmProps) => void,
		dataIndex: DataIndex,
	  ) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	  };
	  
	  const handleReset = (clearFilters: () => void) => {
		clearFilters();
		setSearchText('');
	  };
	  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
		  <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
		  <Input
		  ref={searchInput}
		  placeholder={`Search ${dataIndex}`}
		  value={selectedKeys[0]}
		  onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
		  onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  style={{ marginBottom: 8, display: 'block' }}
		  />
		  <Space>
		  <Button
		  type="primary"
		  onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  icon={<SearchOutlined />}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Search
		  </Button>
		  <Button
		  onClick={() => {
			setSelectedKeys([]);
			handleSearch([], confirm, dataIndex);
		  }}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Reset
		  </Button>
		  </Space>
		  </div>
		),
		filterIcon: (filtered: boolean) => (
		  <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
		),
		onFilter: (value, record) =>
		  record[dataIndex] && record[dataIndex]
		.toString()
		.toLowerCase()
		.includes((value as string).toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
		  if (visible) {
			setTimeout(() => searchInput.current?.select(), 100);
		  }
		},
		render: (text) =>
		  searchedColumn === dataIndex ? (
		  <Highlighter
		  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
		  searchWords={[searchText]}
		  autoEscape
		  textToHighlight={text ? text.toString() : ''}
		  />
		) : (
		  text
		),
	  });

  const addkeytoData = (data:any) => {
    let tempData = [...data];
    tempData.map((item:any,index:number) => {
        item.key = index+1;
    });
    return tempData;
    }
    // useEffect(() => {
    //     if(ischildDataRefresh){
    //         fetchChildOppData();
    //         refreshchildData(false);
    //     }
    // },[ischildDataRefresh])

    const getSelectedBu = (selectedBu:any[]) => {
      let tempSelectedBuList = [];
      tempSelectedBuList = selectedBu.map((item:any) => {
        return item.value;
      });
      return tempSelectedBuList;
      }

  const fetchChildOppData = async () => {
    setLoading(true);
    setDataCalled(true);
    dispatch(fetchOBOReport_AllChildOpps({
                'payload':{'parentOppID': parentOpp.opportunityID ,'startDate':filterData.startDate,'endDate':filterData.endDate, 
                  'clientName':filterData.clientName,
                  'buName':getSelectedBu(filterData.buName),
                  'page':0,
                  'size':10,
                  'filters':filters
                }
                })).then((res:any) => {
                if(res.type==="oboReports/fetchOBOReport_AllChildOpps/fulfilled"){
                    if(res.payload.content?.length>0){
                        // setOBOReportData(res.payload.data);
                        let _temp = addkeytoData(res.payload.content);
                        setChildOppData(_temp);
                        setTotalCount(res.payload?.totalElements);
                        setLoading(false);
                    }
                    setLoading(false);
                }
                else{
                    rejectedApiMessage(res.payload);
                    setLoading(false);
                }
                
            }
        );
  };

  useEffect(() => {
    if (parentOpp && parentOpp.opportunityID && !dataCalled) {
      console.log("child useEffect  in" , parentOpp, dataCalled);
      fetchChildOppData();
      // refreshchildData(false);
    }
  }, [parentOpp , ischildDataRefresh]);

  const columns : TableColumnsType<DataType> = [
        
        {
          title: 'Client Name',
          dataIndex: 'client',
          key: 'client',
          width: '150px',
          fixed: 'left',
        
        //   ...getColumnSearchProps('client'),
        },
        {
          title: 'Opportunity ID',
          dataIndex: 'opportunityID',
          key: 'opportunityID',
          width: '150px',
        //   fixed: 'left',
          ...getColumnSearchProps('opportunityID'),
        },
        {
          title: 'Opportunity Name',
          dataIndex: 'opportunityName',
          key: 'opportunityName',
          width: '200px',
          render: (text: any, record: any) => {
            return(
                <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
                {text}
              </div>
            )
        },
          ...getColumnSearchProps('opportunityName'),
        },
        {
          title: 'Contract Value',
          dataIndex: 'sumOfTCV',
          key: 'sumOfTCV',
          width: '100px',
          render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
          }
        },
        {
          title: 'Revenue For Period',
          dataIndex: 'revenue',
          key: 'revenue',
          width: '100px',
          render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
          }
        },
        {
            title: 'Total Revenue',
            dataIndex: 'totalRevenue',
            key: 'totalRevenue',
            width: '100px',
            render: (text: any, record: any) => {
              return(
                <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
              )
            }
          },
        {
          title: 'OBO Value',
          dataIndex: 'obo',
          key: 'obo',
          width: '100px',
          render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
          }
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: '100px',
          render: (text:any, record: any, rowIndex :any ) => {
            return(
                <>

                {
                    record.countOfSowDetails > 0 && 
                    <Button type='link' className = { rowIndex % 2 === 0 ? 'opps-button-odd' : 'opps-button-even'} onClick={()=>openSOWFromChild(record,[{'levelName':"ParentOpps",'levelData':parentOpp},{'levelName':"ChildOpps",'levelData':record}])}>{record.countOfSowDetails} Sows</Button>
                }
                </>
            //   <Button type='link' className='opps-button' onClick={()=>viewOBOModal(record)}>12 OPPs</Button>
            )
          }
        },
      ];

  return (
    <Spin spinning={loading}>
        <div style={{ marginBottom: '16px', marginLeft:'35px', paddingTop:'10px' }}>
        
        <div><span className='header-obo'> Child Opportunities</span> <span className='obo-count-label'>{parentOpp.countOfChildOpp} </span></div>
      </div>
      {!loading && <Table
        dataSource={childOppData}
        columns={columns}
        style={{
          marginLeft: '35px',
        }}
        className='table-styles child-opportunity-details-table-container'
        rowKey={(record) => record.childOpportunityID}
        pagination={{
          current: pageNo + 1,
          pageSize,
          total: totalCount,
          showSizeChanger: false,
        }}
        onChange={handleTableChange}
        scroll={{ x: 'max-content',y:200}}
      />}
    </Spin>
  );
};

export default OboChildOppDetailsTableContainer;